import React from 'react';
import { connect } from 'react-redux'
import actions from '../../redux/actions'
import CameraComponents from '../../components/Camera/index'
import { FACING_MODES, IMAGE_TYPES } from 'jslib-html5-camera-photo';

class CameraIDCard extends React.Component {
    constructor (props, context) {
        super(props, context);
        this.onTakePhoto = this.onTakePhoto.bind(this);
    }

    onTakePhoto (dataUri) {
      this.props.setIDCardPicture(dataUri);
      this.props.history.push('/id-card-loading');
    }

    render () {
        console.log(window.innerWidth, window.innerHeight)
        return (
            <CameraComponents
              onClick = {() => this.props.history.push('/how-to-id-card')}
              onTakePhoto = { (dataUri) => { this.onTakePhoto(dataUri); } }
              idealFacingMode = {FACING_MODES.ENVIRONMENT}
              // idealResolution = {{width: 0 , height: 1400}}
              resolution = {{width: window.innerWidth, height: window.innerHeight}}
              imageType = {IMAGE_TYPES.JPG}
              imageCompression = {0.97}
              isMaxResolution = {false}
              isImageMirror = {false}
              isDisplayStartCameraError = {true}
              isFullscreen = {true}
              sizeFactor = {1}
            />
        );
    }
}

const mapDispatchToProps = {
  setIDCardPicture: actions.setIDCardPicture,
}

const CameraIDCardWithConnect = connect(null, mapDispatchToProps)(CameraIDCard)

export default CameraIDCardWithConnect
